import { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { CategoryEntity } from '../dto/category/CategoryEntity';
import { CategoryModel } from '../dto/category/CategoryModel';
import { CategorySearch } from '../dto/category/CategorySearch';
import { BaseResponse } from '../dto/response/BaseResponse';
import { ReadResponse } from '../dto/response/ReadResponse';
import { AttributeChoiceModel } from '../dto/attribute/AttributeChoiceModel';
import { ApiClient } from '../util/ApiUtility';
import { CategoryDetailEntity } from '../dto/category/CategoryDetailEntity';
import { CategoryMediaEntity } from '../dto/category/CategoryMediaEntity';
import { CategoryAttributeEntity } from '../dto/category/CategoryAttributeEntity';
import { CategoryAttributeChoiceEntity } from '../dto/category/CategoryAttributeChoiceEntity';
import { CategoryBrandEntity } from '../dto/category/CategoryBrandEntity';
import Delete from '@mui/icons-material/Delete';

export const onCategoryDetail = async (categoryId: number) => {
  const requestConfig: AxiosRequestConfig = {
      headers: {
      'Content-Type': 'application/json',
      },
      method: 'GET',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/' + categoryId
  }
  const response = await ApiClient().request<BaseResponse<CategoryDetailEntity>>(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onCategorySubmit = async (formData: FormData) => {
    const requestConfig: AxiosRequestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'POST',
      url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/init',
      data: formData
    }

    let response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        throw new Error("Амжилтгүй");
    }
}

export const onCategoryMediaUpload = async (formData: FormData) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/media/init',
    data: formData
  }

  let response = await ApiClient().request<BaseResponse<CategoryMediaEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onCategoryMediaDelete = async (media: CategoryMediaEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/media/delete/' + media.id
  }

  let response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onCategoryBasicUpdate = async (category: CategoryEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/update',
    data: category
  }

  let response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
      return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onCategoryList = async (top?: boolean, name?: string) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category'
    + (top !== undefined ? ("&top=" + top) : "") 
    + (name !== undefined ? ("&name=" + name) : "")
  }
  var response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    const cats = response.data;
    return cats;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onCategorySearch = async (data: CategorySearch) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category',
    params: {
      id: data.id,
      parentIds: data.parentIds && data.parentIds.length > 0 ? data.parentIds.join(',') : null,
      top: data.top,
      freightRequiredFlag: data.freightRequiredFlag,
      offset: data.offset,
      limit: data.limit
    }
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}


export const onCategoryLeafAttributeChoices = async (categoryId: string) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/leaf-available-attributes/' + categoryId
  }
  const response = await ApiClient().request<ReadResponse>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onCategory = async (categoryId: string) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category',
    params: {
      id: categoryId
    }
  }
  const categoryResponse = await ApiClient().request<ReadResponse>(requestConfig);
  if (categoryResponse.status >= 200 && categoryResponse.status < 300) {
    return categoryResponse.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onAttributeList = async (categoryId?: number, attrId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute',
    method: 'GET',
    params: {
      offset: 0,
      limit: 100000,
      orderBy: 'id',
      sortBy: 'ASC',
      categoryIds: categoryId !== undefined ? categoryId : null,
      id: attrId !== undefined ? attrId : null
    }
  }

  const attributeList = await ApiClient().request<ReadResponse>(requestConfig);
  if (attributeList.status >= 200 && attributeList.status < 300) {
    return attributeList.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onAttributeChoiceList = async (categoryId?: number, attributeId?: number, id?: number, brandId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/choice',
    method: 'GET',
    params: {
      id: id,
      attributeId: attributeId,
      categoryId: categoryId,
      brandId: brandId,
      offset: 0,
      limit: 1000000
    }
  }

  const attributeChoiceList = await ApiClient().request<ReadResponse>(requestConfig);
  if (attributeChoiceList.status >= 200 && attributeChoiceList.status < 300) {
    return attributeChoiceList.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onCategoryAttributeChoiceList = async (categoryId?: number, attributeId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/' + categoryId + '/attribute/' + attributeId + '/choice',
    method: 'GET'
  }
  const categoryAttributeChoiceList = await ApiClient().request<ReadResponse>(requestConfig);
  if (categoryAttributeChoiceList.status >= 200 && categoryAttributeChoiceList.status < 300) {
    return categoryAttributeChoiceList.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}

export const onCategoryAttributeCreate = async (categoryAttribute: CategoryAttributeEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/link-attribute',
    data: categoryAttribute
  }
  const response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onAddAttributeChoiceToCategory = async (categoryAttribute: CategoryAttributeEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/add-attribute-choice',
    data: categoryAttribute
  }
  const response = await ApiClient().request<BaseResponse<CategoryAttributeEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onBrandList = async (categoryId?: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/brand',
    method: 'GET'
  }
  if (categoryId !== undefined) {
    requestConfig.params = {
      categoryIds: categoryId
    }
  } else {
    requestConfig.params = {
      offset: 0,
      limit: 100000,
      orderBy: 'id',
      sortBy: 'ASC'
    }
  }
  const brandList = await ApiClient().request<ReadResponse>(requestConfig);
  if (brandList.status >= 200 && brandList.status < 300) {
    return brandList.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}


export const onCategoryBrandCreate = async (categoryBrand: CategoryBrandEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/link-brand',
    data: categoryBrand
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onUnlinkAttributeFromCategorySubmit = async (unlinkAttribute: CategoryModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category',
    data: unlinkAttribute
  }
  const response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onRemoveAttributeChoiceFromCategory = async (categoryAttributeChoice: CategoryAttributeChoiceEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/remove-attribute-choice',
    data: categoryAttributeChoice
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onRemoveBrandFromCategory = async (categoryBrand: CategoryBrandEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/remove-brand',
    data: categoryBrand
  }
  const response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onCategoryAttributeUpdate = async (categoryAttribute: CategoryAttributeEntity) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category/attribute-update',
    data: categoryAttribute
  }
  const response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}



export const onCategoryLeafAttributeChoice = async (data: AttributeChoiceModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/choice',
    data: data
  }
  const response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onCategoryDelete = async (id: number) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/category?id=' + id
  }
  const response = await ApiClient().request<BaseResponse<any>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}

export const onAttributeChoiceSubmit = async (choiceModel: AttributeChoiceModel) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/choice',
    data: choiceModel
  }
  const response = await ApiClient().request<BaseResponse<CategoryEntity>>(requestConfig);
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
      throw new Error("Амжилтгүй");
  }
}